import { Container, ErrorSection } from './OopsErrorSection.styles';

/**
 * Decorative section for displaying an error message.
 */
export default function OopsErrorSection({
  children
}: React.PropsWithChildren) {
  return (
    <ErrorSection>
      <Container>{children}</Container>
    </ErrorSection>
  );
}
